module.exports = __webpack_public_path__ + "img/purple-check.6ab49520.svg";